import { render, staticRenderFns } from "./MHeader.vue?vue&type=template&id=4700ec94&scoped=true"
import script from "./MHeader.vue?vue&type=script&lang=js"
export * from "./MHeader.vue?vue&type=script&lang=js"
import style0 from "./MHeader.vue?vue&type=style&index=0&id=4700ec94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4700ec94",
  null
  
)

export default component.exports